export default __webpack_public_path__ + "static/media/flag-sahrawi-arab-democratic-republic.8a49b230.svg";